import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMail24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4 19h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m14.586-2-3.856-3.856L12 15.267l-2.73-2.123L5.414 17zM20 15.586V9.045l-3.68 2.861zM4 9.045v6.54l3.68-3.679zM4.629 7 12 12.733 19.371 7z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconMail24);
export default ForwardRef;
